// AICounsellingAIHistory.jsx
import React, { useCallback, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
// import MainLayout from '../../layouts/MainLayout';
import './styles/AICounsellingHistory.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift, faWallet } from '@fortawesome/free-solid-svg-icons';

const AICounsellingAIHistory = () => {
  const authState = useSelector(state => state.authReducer);
  const [userId, setUserId] = useState(authState.user._id);
  const [fetchData, { loading }] = useFetch();
  const navigate = useNavigate();
  const [counsellingBalanceAmount, setCounsellingBalanceAmount] = useState(0.00);
  const [counsellingLastUpdated, setCounsellingLastUpdated] = useState();
  const [counsellingLastUpdatedRemarks, setCounsellingLastUpdatedRemarks] = useState('');

  const [counsellingData, setData] = useState([]);
  const [selectedCounsellingId, setSelectedCounsellingId] = useState([]);

  //Counselling History
  const fetchCounselling = useCallback(() => {
    const config = {
      url: "/aicounselling/myaihistory",
      method: "post",
      headers: { Authorization: authState.token },
      data: {userId: userId}
    };

    fetchData(config, { showSuccessToast: false })
      .then(response => {
        // console.log("Response:", response);
        if (response && Array.isArray(response)) {
          setData(response);
        } else {
          console.error("Invalid response format: Counselling data not found in response");
        }
      })
      .catch(error => {
        console.error("Error fetching Counselling data:", error);
      });
  }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchCounselling();
  }, [authState.isLoggedIn, fetchCounselling]);

  const sortedCounsellingData = [...counsellingData].sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated));

  const handleCounsellingView = (_id) => {
    setSelectedCounsellingId(prevId => (prevId === _id ? null : _id));
  };

  const handleTopupClick = (userId) => {
    navigate('/wallet-counsellingtransfer', { state: { userId: userId } });
  };

  const formatDateTime = (date) => {
    const options = {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div>
      <header
          className="
              sticky top-0 z-50 
              bg-black 
              px-4 py-3 
              flex flex-col items-center justify-center
              shadow-md border-b border-blue-400
          "
          >
          <div className="flex flex-row gap-4 items-center justify-center">
              <div className="flex flex-col items-center mt-2 p-4">
                  <h1 className="text-xl text-yellow-200 mt-1">My Think5Whys AI Counselling History</h1>
              </div>
          </div>
      </header>

      <div>
        <div className="bg-black p-2 mt-2 rounded-lg shadow-lg">
          {loading ? (
            <Loader />
          ) : (
            <div>
              {counsellingData && counsellingData.length === 0 ? (
                <div className="flex items-center justify-center text-yellow-300 text-lg h-64">
                  No records found!
                </div>
              ) : (
                <div className="space-y-1">
                  {sortedCounsellingData.map((counsellingItem, index) => (
                    <div
                      key={counsellingItem._id}
                      className="bg-black border border-gray-700 p-2 rounded-lg shadow-lg text-white"
                    >
                      <div className="flex justify-between items-center">
                        <span className="font-medium text-white">
                          {index + 1}. Date & Time: {formatDateTime(counsellingItem.dateCreated)}{" "}
                        </span>

                        <Tooltip text="View details" position="top">
                          <span
                            className="text-white cursor-pointer hover:text-yellow-400 transition"
                            onClick={() => handleCounsellingView(counsellingItem._id)}
                          >
                            <i className="fa-solid fa-eye"></i>
                          </span>
                        </Tooltip>
                      </div>

                      {selectedCounsellingId === counsellingItem._id && (
                        <div className="mt-4 bg-black border border-blue-400 p-4 rounded-lg shadow-inner space-y-2">
                          <p>
                              <strong>Counsellor Name: </strong>
                              {counsellingItem.counsellorName === '' 
                                  ? "Self With ThinkAIInsight" 
                                  : counsellingItem.counsellorName}
                          </p>
                          <p><strong>Aptitude Score: </strong> {counsellingItem.aptitudeScore}</p>
                          <p><strong>Interest Areas: </strong> {counsellingItem.interestAreas}</p>
                          <p><strong>Personality Type: </strong> {counsellingItem.personalityType}</p>
                          <p><strong>Career Goal: </strong>{counsellingItem.careerGoal}</p>

                          <div className='bg-black border border-teal-700 py-4 px-4'>
                            <p className='text-yellow-200'><strong>Periodic Psychometric Test: </strong></p>
                            {counsellingItem.psychometric && counsellingItem.psychometric.length > 0 ? (
                              counsellingItem.psychometric.map((category, catIndex) => (
                                <div key={catIndex} className="psychometric-category mb-4 ml-2">
                                  <div>
                                    <strong>{String.fromCharCode(65 + catIndex)}. {category.category}: </strong>
                                  </div>
                                  <ul className="list-none pl-0 ml-6">
                                    {category.questions.map((question, qIndex) => (
                                      <li key={qIndex} className="mb-3">
                                        
                                        <strong>{qIndex+1}. Question:</strong> {question.question} <br />
                                        <strong>Selected Option:</strong> {question.selectedOption}
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              ))
                            ) : (
                              <p>No psychometric data available.</p>
                            )}
                          </div>

                          <div className='bg-black border border-gray-700 py-4 px-4'>
                            <p><strong>Exam Title: </strong> {counsellingItem.examTitle}</p>
                            <p className='text-yellow-200'><strong>Academic Score Subjects: </strong></p>
                            {counsellingItem.subjects && counsellingItem.subjects.length > 0 ? (
                              counsellingItem.subjects.map((subject, subIndex) => (
                                <div key={subIndex} className="subject-item ml-4">
                                  <div>
                                    <strong>{subIndex+1}. {subject.name}: </strong> {subject.marks}%
                                  </div>
                                </div>
                              ))
                            ) : (
                              <p>No subject data available.</p>
                            )}
                        </div>

                        <div className="bg-black border border-blue-800 py-4 px-4">
                            <p><strong>Timeline: </strong>{counsellingItem.timeline} months</p>
                            <p className='text-yellow-200'><strong>Target Milestones: </strong></p>
                            {counsellingItem.milestones && counsellingItem.milestones.length > 0 ? (
                              <ul className="list-none pl-0 ml-4">
                                {counsellingItem.milestones.map((milestone, mileIndex) => (
                                  <li key={mileIndex} className="text-white">
                                    <strong>{mileIndex+1}. {milestone}</strong>
                                  </li>
                                ))}
                              </ul>
                            ) : (
                              <p className="text-white">No milestones available.</p>
                            )}
                          </div>
                          <div className='bg-black border-2 border-gray-500 py-4 px-4'>
                            <p><strong>Aptitude Code: </strong>{counsellingItem.aptitudeCode}</p>
                            <p><strong>Academic Data Code: </strong>{counsellingItem.academicDataCode}</p>
                            <p><strong>Milestone Code: </strong>{counsellingItem.milestoneCode}</p>
                            <p><strong>RCA Code: </strong>{counsellingItem.rcaCode}</p>
                          </div>  
                          {/* <p><strong>AI Assessment: </strong>dangerouslySetInnerHTML={{ __html: counsellingItem.aiAssessment }}</p> */}
                          <div className='bg-black border border-gray-600 py-4 px-4'>
                            <p><strong className='text-orange-200'>AI Assessment: </strong><span dangerouslySetInnerHTML={{ __html: counsellingItem.aiAssessment }} /></p>
                          </div>
                          <div className='bg-black border border-blue-600 py-4 px-4'>
                            <p><strong className='text-orange-200'>Counsellor Report: </strong><span dangerouslySetInnerHTML={{ __html: counsellingItem.counsellorReport }} /></p>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <footer className="sticky bg-black border-t border-blue-400 text-white py-2 px-4 mt-2">
          <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left space-y-4 md:space-y-0">
              <p className="text-xs sm:text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions.</p>
              <div className="flex flex-row gap-2 sm:gap-6 text-xs sm:text-sm">
              <Link to="/about-us" className="text-white hover:text-purple-200 transition">About</Link>
              <Link to="/privacy-policy" className="text-white hover:text-purple-200 transition">Privacy Policy</Link>
              <Link to="/terms-of-use" className="text-white hover:text-purple-200 transition">Terms of Use</Link>
              <Link to="/contact-us" className="text-white hover:text-purple-200 transition">Contact</Link>
              </div>
          </div>
      </footer>      
    </div>
  );
};

export default AICounsellingAIHistory;




